import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import BackButton from '../../common/backButton';
import Loader from '../../common/loader';

function ContactUs() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [showLoader, setShowLoader] = useState(true);

    useEffect(() => {
        // Prevent multiple script injections
        if (window.$crisp && window.CRISP_WEBSITE_ID) {
            window.$crisp.push(["do", "chat:show"]);
            window.$crisp.push(["do", "chat:open"]);
            setShowLoader(false);
            return;
        }

        window.$crisp = [];
        window.CRISP_WEBSITE_ID = "eaa3b895-1e50-4e87-9138-c03d126ae2ce";

        const script = document.createElement("script");
        script.src = "https://client.crisp.chat/l.js";
        script.async = true;

        script.onload = () => {
            // Ensure widget is visible
            window.$crisp.push(["do", "chat:open"]);
            setShowLoader(false);
        };

        document.head.appendChild(script);

        return () => {
            try {
                document.head.removeChild(script);
            } catch (e) {}
        };
    }, []);

    const closeChat = () => {
        window.$crisp.push(["do", "chat:close"]);
        navigate(-1);
    };


    return (
        <>
            <style>{`
                #crisp-chatbox div[aria-label="Close chat"] {
                    display: none !important;
                }
                #crisp-chatbox div[data-chat-status="ongoing"],
                #crisp-chatbox div[data-chat-status="initial"] {
                    max-height: calc(100dvh - 76px) !important;
                    margin-top: auto !important;
                }
                html:has(#crisp-chatbox), html:has(#crisp-chatbox)>body {
                    width: auto !important;
                    height: auto !important;
                }
            `}</style>
            {showLoader && <Loader />}
            <div className='wrapper h-100 px-0 pb-0'>
                <div className="px-3">
                    <BackButton label={t('Home')} closeFunction={closeChat} />
                </div>
                <div id="crisp-chat-container"></div>
            </div>
        </>
    );
}

export default ContactUs;